export default () => {

  const items = document.querySelectorAll('.js-dropdown-item')
  const pageheader = document.querySelector('.js-page-header')

  if (! items.length ) {
    return
  }

  // go through all dropdowns
  ;[...items].forEach(item => {

    const target = item.querySelector('.js-dropdown-target')
    const content = item.querySelector('.js-dropdown-content')

    // add class if hover
    content.addEventListener('mouseover', e => {
      target.classList.add('c-main-nav__dropdown--active')

      // remove class if hover away
      if ( pageheader ) {
        pageheader.addEventListener('mouseleave', e => {
          target.classList.remove('c-main-nav__dropdown--active')
        })
      }

    })

  }) // end loop

}



// WEBPACK FOOTER //
// ./src/js/modules/NavDropdown.js